// extracted by mini-css-extract-plugin
module.exports = {"preloader":"preloader__preloader__A4I9e","loader":"preloader__loader__1Zsjy","spin":"preloader__spin__sD1vf"};